import React, { useEffect, useState } from 'react';
import './Shop.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import PURCHASESHOP from '../images/PURCHASESHOP.jpg';
import RENTALSHOP from '../images/RENTALSHOP.jpg';
import LEASESHOP from '../images/LEASESHOP.png';
import SHOPSALE from '../images/SHOPSALE.jpg';
import TAMILNADUMAP from '../images/TAMILNADUMAP.png'; // Adjust path as necessary
import SHOPHEROPIC from '../images/SHOPHEROPIC.jpg'; // Adjust path as necessary 
import Topbar from './Topbar';
import Reviews from './Reviews';

import Rating from './Rating';
import Upload from './Upload';


export default function Shop() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };


  return (
    <div>
      <div><Topbar/></div>
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${SHOPHEROPIC})` }}>
        <div className="hero-content">
          <h1>APPOLLO AGENCY</h1>
          <p>SALES, RENT, LEASE</p>
          <a href="tel:+919884226561" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Apollo Agency! With over 32 years of dedicated experience, we are proud to be your trusted partner for shop rentals, sales, purchases, and leases. We understand how important it is to find the perfect space for your business, whether you're starting a new venture or expanding your current one. Our expert team is here to ensure you secure the ideal shop space, tailored to your needs and goals.

At Apollo Agency, transparency is at the heart of our service. Trust is the foundation of our relationship with you, which is why we keep you informed at every step of the transaction process. Our experienced professionals provide clear and honest guidance, explaining the costs and methods involved in securing the right shop for your business.

Customer satisfaction is our top priority. We are committed to providing timely, dependable service, so you can rely on us for all your shop-related needs. Whether you're renting, buying, or leasing, our team is ready to help you make the best decision and get your business set up in the perfect location. Let us help you achieve your business goals with confidence and ease.</p>
            </div>
          </div>
        </div>
      </section>







      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>Purchase | Sale | Rent | Lease</h2>


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={TAMILNADUMAP} alt="Gallery Image 1" className="img-fluid rounded" />

</div>
<h5>Tamil Nadu</h5>
</div>

</div>
</section>









<section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={PURCHASESHOP} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>purchase Shop</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency, we pride ourselves on offering a seamless and transparent experience in buying, selling, renting, and leasing properties. With over 32 years of expertise in the real estate industry, our team is dedicated to helping you find the right home at the best value.

We understand that purchasing a house is a significant milestone, and we are here to guide you every step of the way. From identifying the perfect property to negotiating the most valuable deals, our experienced professionals ensure a smooth process tailored to your needs.

At Apollo Agency, trust is the cornerstone of our community. We are committed to transparency in pricing and process, providing clear and honest communication at every stage. Our goal is to empower you to make confident decisions and achieve your property dreams with ease.

Choose Apollo Agency—your trusted partner in finding the right home, at the right cost, with the utmost trust and reliability.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={RENTALSHOP} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Rental Shop</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency provides affordable rental solutions, ensuring you find the perfect home without stretching your budget. With over 16 years of trusted service, our experienced team specializes in connecting clients to a wide variety of rental properties, from cozy apartments to spacious houses, across prime locations.

At Apollo Agency, we prioritize transparency in pricing, offering honest guidance and tailored options to match your needs. Our dedicated professionals ensure a seamless rental process, helping you secure a home that aligns with your preferences and lifestyle.

Whether you're searching for a short-term lease or a long-term rental, Apollo Agency is committed to delivering timely and effective assistance, ensuring you find the right home at the right cost. Choose Apollo Agency for a reliable and stress-free rental experience.</p>
    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={LEASESHOP} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Lease Shop</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency is your trusted partner for finding the perfect lease house that meets your needs and lifestyle. With over 16 years of experience, we specialize in connecting clients with a wide range of leasing options, from cozy apartments to spacious family homes, across prime locations.

At Apollo Agency, we prioritize transparency, offering clear and competitive pricing along with dependable assistance throughout the leasing process. Our team ensures that every property is vetted to provide you with a seamless and stress-free experience.

We are committed to delivering fast and efficient service, helping you secure a lease house that fits your preferences and budget. Choose Apollo Agency for a reliable, hassle-free journey to finding your ideal home..</p>
    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={SHOPSALE} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Sale Shop</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>Apollo Agency provides affordable rental solutions, ensuring you find the perfect home without stretching your budget. With over 16 years of trusted service, our experienced team specializes in connecting clients to a wide variety of rental properties, from cozy apartments to spacious houses, across prime locations.

At Apollo Agency, we prioritize transparency in pricing, offering honest guidance and tailored options to match your needs. Our dedicated professionals ensure a seamless rental process, helping you secure a home that aligns with your preferences and lifestyle.

Whether you're searching for a short-term lease or a long-term rental, Apollo Agency is committed to delivering timely and effective assistance, ensuring you find the right home at the right cost. Choose Apollo Agency for a reliable and stress-free rental experience.</p>
    </div>
  </div>


</section>





<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>
    


<div><Reviews/></div>

{/* Other sections */}
<section id="faq-shop">
  <div className="container">
    <h2>FAQs - Frequently Asked Questions</h2>
    <div className="accordion">
      {[
        { 
          question: "How can Apollo Agency assist with shop purchases?", 
          answer: "We provide comprehensive support, including property search, documentation, and negotiation, ensuring a seamless purchase experience." 
        },
        { 
          question: "What services do you offer for shop rentals?", 
          answer: "We offer a curated selection of rental shops to match your business needs, along with support for legal and contractual requirements." 
        },
        { 
          question: "Can Apollo Agency help with shop lease agreements?", 
          answer: "Yes, we handle all aspects of shop leasing, including finding tenants, tenant screening, and preparing compliant lease agreements." 
        },
        { 
          question: "Do you assist with shop sales?", 
          answer: "We connect sellers with serious buyers, provide accurate market insights, and negotiate deals to maximize value." 
        },
        { 
          question: "Why should I choose Apollo Agency for shop-related needs?", 
          answer: "Our expertise, transparent processes, and dedication to client satisfaction make us a reliable choice for shop rentals, purchases, sales, and leases." 
        },
        { 
          question: "Do you provide any special deals or offers?", 
          answer: "Yes, we offer exclusive seasonal discounts and referral rewards for our valued clients." 
        },
      ].map((faq, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={() => toggleFaq(index)}>
            <h3>{faq.question}</h3>
            <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
          </div>
          <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>13.A, Sudhanadha Bharathi St.,</p>
      <p>East Tambaram, Chennai-600059</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +919884226561<br/>Email: info.appolloagency@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
        <a href="https://www.google.com/maps?q=Chennai" target="_blank">View on Google Maps</a>
      </p>
    </div>
  </div>
</section>


      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>



<div>
  <Rating />
</div>
{/* <div><Upload/></div> */}
    <div><Footer /></div>
  </div>
  </div>
  )
}
